export const MIDIMetaEventNames = {
  0x00: "sequenceNumber",
  0x01: "text",
  0x02: "copyrightNotice",
  0x03: "trackName",
  0x04: "instrumentName",
  0x05: "lyrics",
  0x06: "marker",
  0x07: "cuePoint",
  0x20: "midiChannelPrefix",
  0x21: "portPrefix",
  0x2f: "endOfTrack",
  0x51: "setTempo",
  0x54: "smpteOffset",
  0x58: "timeSignature",
  0x59: "keySignature",
  0x7f: "sequencerSpecific",
} as const
